'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroDrawer = require('./NitroDrawer');

var _NitroDrawer2 = _interopRequireDefault(_NitroDrawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroDrawer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-drawer/index.js
// module id = 64
// module chunks = 4